<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Q09TCV/tc-custom/9781459203488.jpg?1741129861329" alt="This image is the cover for the book His Brother's Wife"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">His Brother's Wife
      </h1>
      <p class="bookDescription body article font2">
        <b>A man marries his dead brother’s wife to satisfy the terms of a will in this inspirational romance from a <i>New York Times</i>–bestselling author.</b><br/><br/>Widowed young, deep in debt, lacking even children to cherish, Lily felt lower than her precious Texas bayous. Until her late husband’s brother—her long-ago love—came back to town, vowing to watch over her always. . . .<br/><br/>Clearly, city bachelor Mason Winslow felt honor-bound to make Lily his wife. But what was Lily to do with the wayward emotions he evoked? The hidden guilt that lapped at her soul? For Mason’s blue eyes and bittersweet smile made her shiver like wind over water, and she secretly yearned for his kiss. And Lily couldn’t decide whether marrying her husband’s brother would be a betrayal . . . or a blessing.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lenora Worth
      </h2>
      
      <p class="authorDescription body article">Lenora Worth writes for&#160;Love Inspired and Love Inspired Suspense. She is a Carol Award finalist and&#160;a <I>New York Times</I>, <I>USA Today</I>, and <I>PW</I> bestselling author. She&#160;writes Southern stories set in places she loves such as Georgia, Texas, &#160;Louisiana, and Florida. Lenora is married and has two grown children and now lives near the ocean in the Panhandle of Florida. She loves reading, shoe shopping, long walks on the beach, mojitoes and road trips.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?01ac5f71